export const getLogin = (state: any) => state.login;
export const getWallet = (state: any) => state.wallet;
